import './App.css';
import './Styles/style.css'
import './Styles/styles.css'
import './Styles/theme.css'
import './Styles/toastr.css'
import './Styles/vendor.css'
import {BrowserRouter, Routes, Route} from "react-router-dom"
import Login from './pages/Login/Login';
import Layout from './components/Layout'
import ProtectedRoutes from './utils/ProtectedRoutes';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from './context/AuthContext';
import ForgotPassword from './pages/Login/ForgotPassword';
import VerifyResetCode from './pages/Login/VerifyResetCode';
import ResetPasswordSent from './pages/Login/ResetPasswordSent';
import Signup from './pages/SignUp/Signup';

// In your src/App.js or src/index.js
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App() {
  return (
    <BrowserRouter> 
    <AuthProvider>
      <Routes>
        <Route path="/sign-up" element={<Signup />} />
        <Route path='' element={<Login />} />
        <Route path="/login/forgot-password" element={<ForgotPassword />} />
        
        {/* Password reset routes - both handled by the same component */}
        <Route path="/verify-reset-code/:token" element={<VerifyResetCode />} />
        <Route path="/reset-password" element={<VerifyResetCode />} />
        <Route path="/reset-password-sent" element={<ResetPasswordSent />} />
        <Route path='/*' element={<ProtectedRoutes component={Layout} />} />
      </Routes>
    </AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={6608}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        />
    </BrowserRouter>
  );
}

export default App;
